/*
 * vue全局方法
 */
import Vue from 'vue';
import ElementUI from 'element-ui';
/*
 * 消息提示全局方法
 * @param {string} msg 消息提示内容
 * @param {string} type 主题 success/warning/info/error
 * */
Vue.prototype.$MyMessage = function (msg, type) {
  if (!type) { type = 'error'; }
  let nMsg = $('.el-message--' + type);
  if (nMsg && nMsg.length > 0) {
    nMsg.find('.el-message__content').text(msg);
  } else {
    ElementUI.Message({
      message: msg,
      type: type,
      // duration: 0
      offset: 100
    });
  }
}
Vue.prototype.Bus = new Vue();
/*
 * 获取字符串长度
 * @param {string} str 字符串
 * @param {int} clen 中文所占字节，默认为2
 * */
Vue.prototype.strLen = function (str, clen) {
  if (!clen) { clen = 2; }
  let ilt = 0;
  if (str && str.length > 0) {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
        ilt += clen;
      } else {
        ilt += 1;
      }
    }
  }
  return ilt;
};
/*
 * 截取字符串
 * @param {string} str 字符串
 * @param {int} len 需要截取的长度
 * @param {int} clen 中文所占字节，默认为2
 * @param {string} siff 结尾，默认为"..."
 * */
Vue.prototype.strCutWithLen = function (str, len, clen, siff) {
  if (!clen) { clen = 2; }
  if (!siff) { siff = '...'; }
  let ilt = 0, idx = 0, srtn = '';
  if (str && str.length > 0) {
    for (let i = 0; i < str.length; i++) {
      if (str.charCodeAt(i) > 127 || str.charCodeAt(i) === 94) {
        ilt += clen;
      } else {
        ilt += 1;
      }
      if (ilt >= len) {
        idx = i - 1;
        break;
      }
    }
    if (idx > 0) {
      srtn = str.substring(0, idx) + siff;
    } else {
      srtn = str;
    }
  }
  return srtn;
};
/**
 * 去掉字符前后中间所有空格
 */
Vue.prototype.Trim = function (str, isGlobal) {
  if (str === null) {
    return false;
  }
  let result;
  result = str.replace(/(^\s+)|(\s+$)/g, '');
  if (isGlobal.toLowerCase() === 'g') {
    result = result.replace(/\s/g, '');
  }
  return result;
};
// 不能超过当前时间限制
Vue.prototype.timeCompare = (startTime, endTime, type=true) => {
  const isStartTime = new Date(startTime).getTime() > new Date().getTime()
  const isEndTime = new Date(endTime).getTime() > new Date().getTime()
  const isCompareTime = new Date(startTime).getTime() > new Date(endTime).getTime()
  if( isCompareTime ) {
    Vue.prototype.$MyMessage("开始时间不能大于结束时间")
    return true;
  }
  if(type) {
    if( isStartTime ) {
      Vue.prototype.$MyMessage("开始时间不能大于当前时间")
      return true;
    }
    if( isEndTime ) {
      Vue.prototype.$MyMessage("结束时间不能大于当前时间")
      return true;
    }
  }
  
}
// 不能小于当前时间限制
Vue.prototype.timeLessCompare = (startTime, endTime) => {
  const isStartTime = new Date(startTime).getTime()  < (new Date().getTime() - 24 * 3600 * 1000)
  const isCompareTime = new Date(startTime).getTime() > new Date(endTime).getTime()
  if( isCompareTime ) {
    Vue.prototype.$MyMessage("开始时间不能大于结束时间")
    return true;
  }
  if( isStartTime ) {
    Vue.prototype.$MyMessage("开始时间不能小于当前时间")
    return true;
  }
}
// 一天的时间限制
Vue.prototype.timeOneCompare = (startTime, endTime, num=1, type=true) => {
  const isStartTime = new Date(startTime).getTime() > new Date().getTime()
  const isEndTime = new Date(endTime).getTime() > new Date().getTime()
  const isOneCompareTime = new Date(endTime).getTime() - new Date(startTime).getTime() > 24*3600000*num
  const isCompareTime = new Date(startTime).getTime() > new Date(endTime).getTime()
  if( isCompareTime ) {
    Vue.prototype.$MyMessage("开始时间不能大于结束时间")
    return true;
  }
  if( isOneCompareTime ) {
    let msg = '开始时间与结束时间需控制在24小时内'
    if(num > 1) {
      msg = `开始时间与结束时间需控制在${num}天内`
    }
    Vue.prototype.$MyMessage(msg)
    return true;
  }
  if(type) {
    if( isStartTime ) {
      Vue.prototype.$MyMessage("开始时间不能大于当前时间")
      return true;
    }
    if( isEndTime ) {
      Vue.prototype.$MyMessage("结束时间不能大于当前时间")
      return true;
    }
  }
}
// 复制
Vue.prototype.copyUrl = (url, e) => {
  $(".copy_str").css({"display": "none"})
  let domUrl = document.createElement("input");
  domUrl.value = url;
  domUrl.id = "creatDom";
  document.body.appendChild(domUrl);
  domUrl.select(); // 选择对象
  document.execCommand("Copy"); // 执行浏览器复制命令
  let creatDom = document.getElementById("creatDom");
  creatDom.parentNode.removeChild(creatDom);
  let content = `<div class="copy_str"><span>复制成功</span></div>`;
  $("#app").append(content)
  const styleCss = {
    top: `${e.y+12}px`,
    left: e.x
  }
  $(".copy_str").css(styleCss)
  setTimeout(() => {
    $(".copy_str").remove()
  },1000)
}